import React from 'react';

export default function MilitaryTuitionAssistanceModalContent() {
  return (
    <p>
      Military Tuition Assistance is a benefit paid to eligible members of the
      Army, Navy, Marines, Air Force, and Coast Guard. Each service has its own
      criteria for eligibility and application process. This money is usually
      paid directly to the institution by the individual service.
    </p>
  );
}
